import React from "react";
import {
  CheckBox,
  ModalButtonsContainer,
  TextButton,
} from "@SeemplicityDev/shared";
import "./DeleteScopeGroupConfirm.scss";

export interface DeleteScopeGroupConfirmProps {
  groupName?: string;
  deleteDescendants: boolean;
  onToggleDeleteDescendants: (value: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  confirmDisabled?: boolean;
}

const DeleteScopeGroupConfirm: React.FC<DeleteScopeGroupConfirmProps> = ({
  groupName,
  deleteDescendants,
  onToggleDeleteDescendants,
  onConfirm,
  onCancel,
  confirmLabel = "Continue",
  confirmDisabled = false,
}) => (
  <div className={"modal-text delete-scope-group-confirm"}>
    <div>
      <span className={"modal-live-text"}>{groupName ?? "This group"}</span>
      {
        " will be deleted. Its sub-groups and scopes will be kept and moved to the top level."
      }
    </div>

    <CheckBox
      checked={deleteDescendants}
      onChange={(_value, isChecked) => onToggleDeleteDescendants(isChecked)}
      label={
        <>
          {"Delete "}
          <span className={"modal-live-text"}>{groupName ?? "this group"}</span>
          {"'s sub-groups and scopes too"}
        </>
      }
      data-testid={"delete-descendants-checkbox"}
    />

    <ModalButtonsContainer>
      <TextButton
        buttonStyle={"secondary"}
        label={"Cancel"}
        onClick={onCancel}
        data-testid={"cancel-delete-scope-group"}
      />
      <TextButton
        buttonStyle={"primary"}
        label={confirmLabel}
        onClick={onConfirm}
        disabled={confirmDisabled}
        data-testid={"confirm-delete-scope-group"}
      />
    </ModalButtonsContainer>
  </div>
);

export default DeleteScopeGroupConfirm;
